<template>

    <div class="p-404">
        <h1 class="p-404__title">
            Strona nie istnieje
        </h1>
        <v-btn type="prev" to="/">
            Wróć
        </v-btn>
    </div>

</template>


<script>

import VBtn from 'Components/VBtn'

export default {

    name: 'View404',

    components: {
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-404 {
    text-align: center;
    color: $c-third;

    &__title {
        margin-bottom: 30px;
    }
}

</style>

